(ns web3.tracking
  (:require [re-frame.core :as rf]
            [com.smxemail.re-frame-cookie-fx]
            [applied-science.js-interop :as j]

            [web3.log :as log]
            [web3.env :as env]
            [web3.tracking.ga :as ga]
            [web3.utils :as utils :include-macros true]
            [web3.auth.api :as auth])
  (:require-macros [web3.static.vendor :refer [hubspot-tracking]]
                   [web3.build.versions :as versions]))

(def env-info
  {:env (env/config :release-flag)
   :stack (env/config :STACKNAME)
   :branch (versions/git-branch)
   :version (versions/version-string)})

;; ========== Facebook Pixel ==========

(rf/reg-fx :facebook.pixel/init
           (fn [{:keys [email nickname]}]
             (when-let [init-pixel (j/get js/window :initFacebookPixel)]
               (init-pixel #js {:em email}))))

;; ========== Hubspot ==========

(defn push-hsq
  [events]
  (let [hsq (or (j/get js/window :_hsq)
                #js [])]
    (.push hsq events)
    (j/assoc! js/window :_hsq hsq)))

(rf/reg-fx :hubspot/init
           (fn [{:keys [email]}]
             (when-let [src (hubspot-tracking)]
               (push-hsq #js ["identify", #js {:email email}])
               (-> (.createElement js/document "script")
                   (j/assoc! :src src
                             :async true
                             :defer true)
                   (->> (.appendChild js/document.body))))))

(defn hubspot-pageview!
  [{:keys [path]}]
  (push-hsq #js ["setPath", path])
  (push-hsq #js ["trackPageView"]))

;; ========== Google Analytics ==========

(rf/reg-fx :tracking/pageview
           (fn [{:keys [path referrer] :as opts}]
             (hubspot-pageview! opts)
             (ga/pageview! opts)))

(rf/reg-fx :tracking/event
           (fn [{:keys [action category label value send_to] :as event}]
             (ga/event! action {"event_category" category
                                "event_label" label
                                "event_value" value})))


(rf/reg-event-fx
 :tracking/registered
 [(rf/inject-cofx :local/get :event/registered?)]
 (fn [{:keys [db event/registered?]} _]
   (log/info "Registered")
   (cond->> {}
     (not registered?)
     (merge {:local/assoc {:event/registered? true}
             :tracking/event {:category "Button"
                              :action "registered"
                              :label "Registration Completed"}}))))
